import { render, staticRenderFns } from "./importGoodsMessage.vue?vue&type=template&id=82965bae&scoped=true"
import script from "./importGoodsMessage.vue?vue&type=script&lang=js"
export * from "./importGoodsMessage.vue?vue&type=script&lang=js"
import style0 from "./importGoodsMessage.vue?vue&type=style&index=0&id=82965bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82965bae",
  null
  
)

export default component.exports